import { getAccount } from 'api/account';
import { create } from 'zustand';

export interface AccountProps {
  _id: string;
  balance: string;
  walletBalance: string;
  profit: string;
  investment: string;
  bitcoin: string;
  ethereum: string;
  litecoin: string;
  usdt: string;
  bnb: string;
  wallet: {
    bitcoin: string;
    ethereum: string;
    litecoin: string;
    usdt: string;
    bnb: string;
  };
  bank: {
    name: string;
    accountName: string;
    swiftCode: string;
    accountNumber: string;
  };
  hasSetupAccount: boolean;
}

export type User = Omit<AccountProps, '_id'>;

interface AccountStoreType {
  account: AccountProps | null;
  errors: string[];
  clearErrors: () => void;
  fetchAccount: () => Promise<void>;
}

const useAccountStore = create<AccountStoreType>((set) => ({
  account: null,
  errors: [],
  clearErrors: () => set((state) => ({ ...state, errors: [] })),
  fetchAccount: async () => {
    try {
      const res = await getAccount();

      if (res?.data) {
        set((state) => ({ ...state, account: { ...res.data } }));
      }
    } catch (error: any) {
      const { errors } = error.response.data;
      errors.forEach((err: { error: string }) => {
        set((state) => ({ ...state, errors: [...state.errors, err.error] }));
      });
      console.log(error);
    }
  },
}));

export default useAccountStore;
